var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHomeOn = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#479DA6",
  d: "M19.82 7.205a4.7 4.7 0 0 0-.79-1.55c-.41-.53-.93-.92-1.88-1.62l-2.6-1.93c-1.46-1.09-2.27-1.68-3.24-1.94-.86-.22-1.76-.22-2.62 0-.97.25-1.73.81-3.24 1.94l-2.6 1.93c-.95.7-1.47 1.09-1.88 1.62-.36.47-.63.99-.79 1.55C0 7.835 0 8.465 0 9.615v2.36c0 2.36 0 4.39.54 5.41.48.9 1.24 1.63 2.19 2.09 1.07.52 2.27.52 4.67.52h5.2c2.4 0 3.6 0 4.67-.52.95-.46 1.7-1.18 2.18-2.09.54-1.02.54-3.06.54-5.41v-2.36c0-1.15 0-1.78-.18-2.41z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#E6F0F1",
  d: "M10 16.105c-2.98 0-4.93-2.31-5.01-2.41a.904.904 0 0 1 .12-1.27c.38-.32.95-.27 1.27.12.03.03 1.52 1.76 3.63 1.76s3.61-1.74 3.63-1.76a.903.903 0 0 1 1.39 1.15c-.08.1-2.03 2.41-5.01 2.41z"
})));
export default SvgIcHomeOn;